import clsx from 'clsx';
import { FC } from 'react';

import { Stepper2Icon } from '@/shared/ui/icon';
export type Stepper2Props = {
	items: string[];
	activeIndex: number;
	onItemClick?: (index: number) => void;
	className?: string;
	disableClickIndexes?: Array<number>;
};

export const Stepper2: FC<Stepper2Props> = ({
	items = [],
	activeIndex = 0,
	onItemClick,
	className = '',
	disableClickIndexes = [],
}) => {
	const handleItemClick = (index: number) => {
		if (disableClickIndexes.includes(index)) {
			return;
		}
		onItemClick?.(index);
	};

	return (
		<div className={clsx('flex items-center gap-6', className)}>
			{items.map((item, index) => {
				const isActive = index === activeIndex;

				return (
					<div key={index} className="flex items-center gap-6">
						<div
							onClick={() => handleItemClick(index)}
							className={clsx(
								'flex items-center',
								onItemClick &&
									!disableClickIndexes.includes(index) &&
									'cursor-pointer hover:opacity-80',
							)}
						>
							<div
								className={clsx(
									'flex h-8 w-8 items-center justify-center rounded-full border border-gray-4 text-sm font-semibold transition-colors',
									isActive && 'border-black bg-black text-white',
									!isActive && 'border-gray-4 text-gray-3',
								)}
								aria-label={`Шаг ${index + 1}: ${item}`}
							>
								{index + 1}
							</div>
							<div
								className={clsx(
									'ml-3 text-sm font-semibold',
									isActive && 'text-black',
									!isActive && 'text-gray-3',
								)}
							>
								{item}
							</div>
						</div>
						{index < items.length - 1 && <Stepper2Icon />}
					</div>
				);
			})}
		</div>
	);
};
